// src/utils/http.js
import axiosInstance from './axios';
 
const http = {
  get(url, params = {}) {
    return axiosInstance.get(url, { params });
  },
  post(url, data = {}) {
    return axiosInstance.post(url, data);
  },
  // 可以继续添加其他方法，如 put, delete 等
};
 
export default http;